module.exports = __webpack_public_path__ + "static/img/hb.35479fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/IntegralProject/images/hb.png
// module id = LGOI
// module chunks = 6